import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UITag from 'UIComponents/tag/UITag';
import ResponsiveRenderer from 'developer-docs-shared-components/components/ResponsiveRenderer';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { useGetBreadcrumbsByUrl } from '../../../hooks/useGetBreadcrumbsByUrl';
import { boldQuery } from '../searchHelpers';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import styled from 'styled-components';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Description = styled.div.withConfig({
  displayName: "ResultDescription__Description",
  componentId: "cnl896-0"
})(["font-size:14px;color:", ";padding-top:16px;margin-bottom:0;padding-right:40px;"], OBSIDIAN);
const StyledVersionTag = styled(UITag).withConfig({
  displayName: "ResultDescription__StyledVersionTag",
  componentId: "cnl896-1"
})(["", "{min-width:fit-content;margin-left:8px;}", "{margin-left:12px;}"], mediaQueries.belowTablet, mediaQueries.aboveTablet);
const StyledDescriptionWrapper = styled.div.withConfig({
  displayName: "ResultDescription__StyledDescriptionWrapper",
  componentId: "cnl896-2"
})(["display:flex;flex-direction:column;padding-right:5px;", "{flex-grow:1;}"], mediaQueries.belowTablet);
const StyledHeaderWrapper = styled.div.withConfig({
  displayName: "ResultDescription__StyledHeaderWrapper",
  componentId: "cnl896-3"
})(["display:flex;align-items:center;", "{justify-content:space-between;}a{font-weight:300;strong{font-weight:700;}}"], mediaQueries.belowTablet);

/**
 * Individual level in a `UIBreadcrumbs` wrapper with private styling removed.
 * @example `API Endpoints` in `API Endpoints > CMS > Pages`
 */
const BreadcrumbsLevel = styled.span.withConfig({
  displayName: "ResultDescription__BreadcrumbsLevel",
  componentId: "cnl896-4"
})(["&&&{font-size:inherit;}"]);
const ResultDescription = ({
  onClick,
  result,
  query
}) => {
  const {
    title,
    version,
    displayText,
    type,
    link
  } = result;
  const breadcrumbs = useGetBreadcrumbsByUrl(type === 'ENDPOINT' ? undefined : {
    title
  }, `/${link}`,
  // include the matching page title in the breadcrumbs for api endpoints
  type === 'ENDPOINT');
  return /*#__PURE__*/_jsxs(StyledDescriptionWrapper, {
    children: [/*#__PURE__*/_jsxs(StyledHeaderWrapper, {
      children: [/*#__PURE__*/_jsx(UIRouterLink, {
        to: `/${link}`,
        onClick: onClick,
        children: boldQuery(title, query)
      }), version && version !== 'Unversioned' && /*#__PURE__*/_jsx(StyledVersionTag, {
        inline: true,
        children: version
      })]
    }), /*#__PURE__*/_jsx(UIBreadcrumbs, {
      flush: true,
      wrapLevels: true,
      children: breadcrumbs.map(({
        name
      }) => /*#__PURE__*/_jsx(BreadcrumbsLevel, {
        children: boldQuery(name, query)
      }, name))
    }), /*#__PURE__*/_jsx(ResponsiveRenderer, {
      renderDesktop: () => /*#__PURE__*/_jsx(Description, {
        children: /*#__PURE__*/_jsx(SanitizedText, {
          body: displayText,
          formattingOptions: {
            shouldPreventAutoLinker: true
          }
        })
      }),
      renderMobile: () => null
    })]
  });
};
export default ResultDescription;